import {generateMultipleItemOverview} from "@/store/baseOverview";

export const namespaced = true;
import BaseStore from "@/store/baseStore";
import { getNewId } from "@/utils/id";
import api from "../api/api"

const baseUrl = "/state_points/";

const baseStore = new BaseStore(baseUrl);
const baseOverview = generateMultipleItemOverview({
  itemFilter: (statePoint, stabSchematisationStage) => statePoint.properties.soil_composition === stabSchematisationStage.soilcomposition,
  duplicationCheckFunc: (statePoint, soilCompositionId) => statePoint.properties.soil_composition === soilCompositionId,
})

const getDefaultState = () => ({
  ...baseStore.state,
  color: "blue",
  generateLoading: false,
});

export const state = {
  ...getDefaultState(),
  ...baseOverview.state,
};

export const mutations = {
  ...baseStore.mutations,
  ...baseOverview.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_COUNT(state, count) {
    state.count = count
  },
  TOGGLE_GENERATE_LOADING(state) {
    state.generateLoading = !state.generateLoading;
  },
};

export const actions = {
  ...baseStore.actions,
  ...baseOverview.actions,
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async fetchItems(context, id) {
    let url = baseUrl + `?search=${id}`;
    let response = await api.get(url);
    context.commit("SET_ITEMS", response.data);
    context.commit("SET_COUNT", response.data.length);
  },
  async add(context) {
    const ids = [];
    const id = getNewId(context.state.items, "id", ids);
    const emptyObj = {
      geometry: {
        coordinates: [0, 0],
        type: "Point",
      },
      id: id,
      properties: { name: "", soil_layer: null, state: "Pop" },
      type: "Feature",
    };
    context.commit("ADD_ITEM", emptyObj);
    context.commit("ADD_COUNT", 1);
  },
  async generate({commit}, {schematisationStageId, soilLayerId}) {
    try {
      commit('TOGGLE_GENERATE_LOADING');
      const url = `${baseUrl}${schematisationStageId}/generate/`;
      const response = await api.post(url, {properties: {soil_layer: soilLayerId}});
      commit('SET_ITEMS', response.data);
    } catch (e) {
      console.log(e);
    } finally {
      commit('TOGGLE_GENERATE_LOADING');
    }
  },
};

export const getters = {
  ...baseOverview.getters,
  getStateTableData: (state, getters) =>  (stabSchematisationStage = null) => {
    const items = getters.getItemsByStabSchematisationStage(stabSchematisationStage);
    if (items.length) {
      return items.map((item) => {
        let obj = {
          id: item.id,
          x: null,
          z: null,
          name: "",
          state: null,
          pop: 0,
          soil_layer: null,
        };
        if (item["geometry"]) {
          obj.x = item["geometry"]["coordinates"][0];
          obj.z = item["geometry"]["coordinates"][1];
        }
        if (item["properties"]) {
          obj.name = item["properties"]["name"];
          obj.soil_layer = item["properties"]["soil_layer"];
          obj.state = item["properties"]["state"];
        }
        return obj;
      });
    }
    return [];
  },
  getPlotData: (state, getters) =>  (stabSchematisationStage = null) => {
    let style = {
      color: state.color,
      size: 6,
      line: {
        color: "black",
        width: 1,
      },
    };
    let point = {
      x: [],
      y: [],
      text: [],
      marker: {},
      mode: "markers",
      type: "scatter",
      name: "State",
      storeNamespace: "state",
      hoverinfo: "none",
    };
    point.x = getters.getStateTableData(stabSchematisationStage).map((item) => item.x);
    point.y = getters.getStateTableData(stabSchematisationStage).map((item) => item.z);
    point.text = getters.getStateTableData(stabSchematisationStage).map((item) => item.name);
    point.marker = style;
    return [point];
  },
};
